export default "__VITE_ASSET__e2583cb3__"